import { useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { SyncResponse } from "../../../types";
import { getAllSync } from "../../queries"; // O usa `any` si no tienes tipo aún

export function useSync() {
  const controllerRef = useRef<AbortController | null>(null);

  const {
    mutate: triggerSyncBase,
    data,
    error,
    isPending: loading,
    isSuccess,
    reset,
  } = useMutation<AxiosResponse<SyncResponse>, Error>({
    mutationFn: async () => {
      // Crear nuevo AbortController por cada llamada
      controllerRef.current = new AbortController();
      return getAllSync({ signal: controllerRef.current.signal });
    },
    onSettled: () => {
      // Limpiar el controller luego de terminar (éxito o error)
      controllerRef.current = null;
    },
  });

  const triggerSync = () => {
    // Cancela si había una previa sin limpiar (precaución)
    controllerRef.current?.abort?.();
    triggerSyncBase();
  };

  const cancelSync = () => {
    controllerRef.current?.abort?.();
  };

  return {
    triggerSync,
    cancelSync,
    message: data?.data?.message ?? "",
    loading,
    isSuccess,
    error,
    reset,
  };
}
